export const Paths = {
  HOME: '/',
  APPS: '/apps',
  APPS_ALL: '/apps/all',
  APPS_ALL_PAGE: '/apps/all/page/:page',
  APPS_CATEGORY: '/apps/:categorySlug',
  APPS_CATEGORY_PAGE: '/apps/:categorySlug/page/:page',
  AGENTS: '/breeze-agents',
  AGENTS_ALL: '/breeze-agents/all',
  AGENTS_ALL_PAGE: '/breeze-agents/all/page/:page',
  AGENTS_TEAM: '/breeze-agents/:teamSlug',
  AGENTS_TEAM_PAGE: '/breeze-agents/:teamSlug/page/:page',
  FEATURED: '/featured',
  FEATURED_PAGE: '/featured/page/:page',
  FEATURED_COLLECTION: '/featured/:collectionSlug',
  LISTING_DETAILS: '/listing/:listingSlug',
  LISTING_DETAILS_WRITE_REVIEW: '/listing/:listingSlug/write-review',
  LISTING_DETAILS_INSTALL_SUCCESS: '/listing/:listingId/install-success',
  LISTING_DETAILS_THIRD_PARTY_AUTH_STATE: '/listing/:listingId/third-party-auth-state',
  SEARCH_RESULTS: '/explore',
  SEARCH_RESULTS_PAGE: '/explore/page/:page'
};
export const SEARCH_RESULTS_PROXY_PATHS = [Paths.APPS_ALL, Paths.APPS_ALL_PAGE, Paths.APPS_CATEGORY, Paths.APPS_CATEGORY_PAGE, Paths.AGENTS_ALL, Paths.AGENTS_ALL_PAGE, Paths.AGENTS_TEAM, Paths.AGENTS_TEAM_PAGE, Paths.SEARCH_RESULTS_PAGE];